export const ESTADO_RUN = {
  ok: { label: 'OK', cls: 'bg-emerald-50 text-emerald-800 border-emerald-200', dot: 'bg-emerald-500' },
  error: { label: 'Error', cls: 'bg-rose-50 text-rose-700 border-rose-200', dot: 'bg-rose-500' },
  sin_datos: { label: 'Sin datos', cls: 'bg-amber-50 text-amber-800 border-amber-200', dot: 'bg-amber-500' },
  omitida: { label: 'Omitida', cls: 'bg-slate-100 text-slate-600 border-slate-200', dot: 'bg-slate-300' },
  en_ejecucion: { label: 'En curso', cls: 'bg-sky-50 text-sky-800 border-sky-200', dot: 'bg-sky-500' },
  interrumpida: { label: 'Interrumpida', cls: 'bg-amber-50 text-amber-800 border-amber-200', dot: 'bg-amber-500' },
};

export const VENTANAS = [{ v: 24, l: '24 h' }, { v: 168, l: '7 días' }, { v: 720, l: '30 días' }];

export const cadaTxt = (min) => {
  if (!min) return null;
  if (min < 60) return `cada ~${Math.round(min)} min`;
  if (min < 1440) return `cada ~${Math.round(min / 60)} h`;
  return `cada ~${Math.round(min / 1440)} días`;
};
